module.exports = __webpack_public_path__ + "img/EXTERIOR-VITARA-2.1183598a.jpg";